import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  public getReport(
    poolId: number,
    cateId: number,
    year: number,
    pageIndex: number = 1,
    pageZise: number = 20
  ) {
    let url = environment.BASE_API_URL + CONSTANTS.API.REPORT.REPORT;
    const params = {
      poolId: poolId.toString(),
      pageIndex: pageIndex.toString(),
      pageSize: pageZise.toString(),
      year: "",
    };
    if (year) {
      params.year = year.toString();
    } else {
      delete params.year;
    }
    if (cateId) params["reportCategoryID"] = cateId.toString();
    return this.http.get<any>(url, { ...this.headers, params }).pipe(
      map((res) => {
        res.result.data = res.result.data ?? [];
        return res;
      })
    );
  }

  public getMidMonthDistribution(
    PoolID: number,
    PageIndex: number = 1,
    PageZise: number = 999,
    ReportCategoryID: number = 3
  ) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.REPORT.MID_MONTHLY_DISTRIBUTION;
    return this.http.get<any>(url, {
      ...this.headers,
      params: {
        ReportCategoryID: ReportCategoryID.toString(),
        PoolID: PoolID.toString(),
        PageZise: PageZise.toString(),
        PageIndex: PageIndex.toString(),
      },
    });
  }

  public getQuarterly(
    PoolID: number,
    PageIndex: number = 1,
    PageZise: number = 999,
    ReportCategoryID: number = 4
  ) {
    let url = environment.BASE_API_URL + CONSTANTS.API.REPORT.QUARTERLY;
    return this.http.get<any>(url, {
      ...this.headers,
      params: {
        ReportCategoryID: ReportCategoryID.toString(),
        PoolID: PoolID.toString(),
        PageZise: PageZise.toString(),
        PageIndex: PageIndex.toString(),
      },
    });
  }

  public getMonthlyDistribution(
    ReportCategoryID: number,
    PoolID: number,
    PageIndex: number = 1,
    PageZise: number = 999
  ) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.REPORT.MONTHLY_DISTRIBUTION;
    return this.http.get<any>(url, {
      ...this.headers,
      params: {
        ReportCategoryID: ReportCategoryID.toString(),
        PoolID: PoolID.toString(),
        PageZise: PageZise.toString(),
        PageIndex: PageIndex.toString(),
      },
    });
  }

  public getMonthlyCommentary(
    PoolID: number,
    FromDate,
    ToDate,
    ReportCategoryID: number = 2,
    PageIndex: number = 1,
    PageSize: number = 999
  ) {
    let url = `${
      environment.BASE_API_URL + CONSTANTS.API.REPORT.MONTHLY_COMMENTARY
    }?ReportCategoryID=${ReportCategoryID}&PoolID=${PoolID}&PageSize=${PageSize}&PageIndex=${PageIndex}&FromDate=${FromDate}&ToDate=${ToDate}`;
    return this.http.get(url, { ...this.headers }).pipe(
      map((res: any) => {
        res.result.data = res.result.data ?? [];
        return res;
      })
    );
  }

  public getCategory() {
    let url = environment.BASE_API_URL + CONSTANTS.API.REPORT.CATEGORY;
    return this.http.get<any>(url, { ...this.headers });
  }

  public getWeekly(
    PoolID: number,
    FromDate,
    ToDate,
    PageIndex: number = 1,
    PageSize: number = 999,
    ReportCategoryID: number = 1
  ) {
    let url = `${
      environment.BASE_API_URL + CONSTANTS.API.REPORT.MONTHLY_DISTRIBUTION
    }?ReportCategoryID=${ReportCategoryID}&PoolID=${PoolID}&PageSize=${PageSize}&PageIndex=${PageIndex}&FromDate=${FromDate}&ToDate=${ToDate}`;
    return this.http
      .get<any>(url, {
        ...this.headers,
      })
      .pipe(
        map((res) => {
          res.result.data = res.result.data ?? [];
          return res;
        })
      );
  }

  public getDocument(reportId: number) {
    const url = environment.BASE_API_URL + CONSTANTS.API.REPORT.DOCUMENT;
    return this.http.get(url, {
      ...this.headers,
      params: { reportId },
      responseType: "blob",
    });
  }
}
